import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dac-article-list',
  templateUrl: './article-list.component.html',
  styleUrls: ['./article-list.component.scss']
})
export class ArticleListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/library-assets/article-list/article-list.component.ts